import styles from "./ContextMenuDivider.module.css";
export const ContextMenuDivider = () => <li aria-hidden="true" class={styles["context-menu-divider"]} />;
